(() => {
  const root = document.getElementById('MinimaCookieConsent');
  if (!root) return;

  const choices = root.querySelector('[data-minima-consent-choices]');
  const customizeButton = root.querySelector('[data-minima-consent-action="customize"]');
  const saveButton = root.querySelector('[data-minima-consent-action="save"]');
  const acceptButton = root.querySelector('[data-minima-consent-action="accept"]');
  const rejectButton = root.querySelector('[data-minima-consent-action="reject"]');
  const localKey = 'minima_customer_privacy_v2';
  let privacyApi = null;

  const nativeSelectors = [
    '#shopify-pc__banner',
    '#shopify-pc__prefs',
    '.shopify-pc__banner__dialog',
    '[data-shopify-cookie-banner]',
    'shopify-privacy-banner',
  ];

  const suppressNativeBanner = () => {
    document.querySelectorAll(nativeSelectors.join(',')).forEach((node) => {
      if (node !== root && !root.contains(node)) {
        node.setAttribute('aria-hidden', 'true');
        node.style.setProperty('display', 'none', 'important');
      }
    });
  };

  const observer = new MutationObserver(suppressNativeBanner);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 12000);
  suppressNativeBanner();

  const show = () => {
    root.hidden = false;
    requestAnimationFrame(() => root.classList.add('is-visible'));
  };

  const hide = () => {
    root.classList.remove('is-visible');
    window.setTimeout(() => {
      root.hidden = true;
    }, 220);
  };

  const hasExplicitDecision = (consent) =>
    ['analytics', 'marketing', 'preferences'].some((key) => consent?.[key] === 'yes' || consent?.[key] === 'no');

  const persistLocalDecision = () => {
    try {
      localStorage.setItem(localKey, new Date().toISOString());
    } catch (_error) {
      // The Shopify consent API remains the source of truth when storage is unavailable.
    }
  };

  const applyConsent = (values) => {
    if (!privacyApi?.setTrackingConsent) return;
    [acceptButton, rejectButton, saveButton].forEach((button) => {
      if (button) button.disabled = true;
    });

    privacyApi.setTrackingConsent(values, () => {
      persistLocalDecision();
      hide();
      document.dispatchEvent(new CustomEvent('minima:consent-saved', { detail: values }));
    });
  };

  acceptButton?.addEventListener('click', () => {
    applyConsent({ preferences: true, analytics: true, marketing: true });
  });

  rejectButton?.addEventListener('click', () => {
    applyConsent({ preferences: false, analytics: false, marketing: false });
  });

  customizeButton?.addEventListener('click', () => {
    const expanded = customizeButton.getAttribute('aria-expanded') === 'true';
    customizeButton.setAttribute('aria-expanded', String(!expanded));
    choices.hidden = expanded;
    acceptButton.hidden = !expanded;
    rejectButton.hidden = !expanded;
    saveButton.hidden = expanded;
    customizeButton.textContent = expanded ? 'Personalizar' : 'Volver';
  });

  saveButton?.addEventListener('click', () => {
    const read = (name) => Boolean(root.querySelector(`[data-minima-consent="${name}"]`)?.checked);
    applyConsent({
      preferences: read('preferences'),
      analytics: read('analytics'),
      marketing: read('marketing'),
    });
  });

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-minima-open-consent]');
    if (!trigger) return;
    event.preventDefault();
    [acceptButton, rejectButton, saveButton].forEach((button) => {
      if (button) button.disabled = false;
    });
    choices.hidden = false;
    customizeButton?.setAttribute('aria-expanded', 'true');
    if (customizeButton) customizeButton.textContent = 'Volver';
    if (acceptButton) acceptButton.hidden = true;
    if (rejectButton) rejectButton.hidden = true;
    if (saveButton) saveButton.hidden = false;
    show();
  });

  const initialize = () => {
    if (!window.Shopify?.loadFeatures) {
      window.setTimeout(initialize, 120);
      return;
    }

    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      (error) => {
        if (error || !window.Shopify?.customerPrivacy) return;
        privacyApi = window.Shopify.customerPrivacy;
        const consent = privacyApi.currentVisitorConsent?.() || {};
        const shouldShow = privacyApi.shouldShowBanner?.() === true;

        if (shouldShow && !hasExplicitDecision(consent)) show();
      },
    );
  };

  initialize();
})();
